module.exports = __webpack_public_path__ + "static/media/WARNING_GRAY.0affa339.svg";